import { ChevronRight, Gamepad2, MapPin, Navigation } from "lucide-react";

function Link({ href, onClick, className, e2e, children }) {
  return href
    ? <a href={href} target="_blank" rel="noopener noreferrer" className={className} data-e2e={e2e}>{children}</a>
    : <button type="button" onClick={onClick} className={className} data-e2e={e2e}>{children}</button>;
}

/** Cartão colorido (mapa, rastreio, joguinho): diz o que faz e tem a ação escrita. */
function Destaque({ href, onClick, icone: Icone, fundo, titulo, sub, acao, e2e }) {
  return (
    <Link href={href} onClick={onClick} e2e={e2e}
      className={`relative overflow-hidden rounded-3xl p-4 text-left text-white shadow-lg active:scale-[0.98] transition-transform flex flex-col min-h-[150px] ${fundo}`}>
      <Icone className="absolute -right-4 -bottom-4 w-24 h-24 opacity-20 rotate-[-12deg]" strokeWidth={1.5} aria-hidden="true" />
      <span className="w-10 h-10 rounded-2xl bg-white/20 grid place-items-center shrink-0"><Icone className="w-5 h-5" /></span>
      <span className="block text-base font-black leading-tight mt-3">{titulo}</span>
      <span className="block text-xs leading-snug mt-1 text-white/85">{sub}</span>
      <span className="relative mt-auto pt-3">
        <span className="inline-flex items-center gap-1 rounded-full bg-white text-gray-900 text-xs font-bold pl-3 pr-2 py-1.5 shadow">
          {acao} <ChevronRight className="w-3.5 h-3.5" />
        </span>
      </span>
    </Link>
  );
}

/**
 * Atalhos logo abaixo do status. Repaginados em 24/10/2026 (dono: "mais
 * chamativo, para o cliente entender o que faz"): o mapa (retirada) ou o
 * rastreio (entrega) e o joguinho em cartões coloridos, cada um com uma frase
 * do que faz e o botão da ação. O WhatsApp saiu daqui: virou o botão fixo do
 * rodapé (RodapeWhatsApp).
 */
export default function Atalhos({ pedido, retirada, emAndamento, abrirMapa }) {
  const cartoes = [];
  if (retirada && pedido?.status !== "cancelado") {
    cartoes.push({ k: "mapa", onClick: abrirMapa, icone: MapPin, fundo: "bg-gradient-to-br from-sky-500 to-blue-600",
      titulo: "Como chegar", sub: "Veja a rota até a loja no mapa do celular", acao: "Abrir mapa", e2e: "atalho-mapa" });
  }
  if (!retirada && pedido?.status === "em_rota" && pedido?.tracking_url) {
    cartoes.push({ k: "rastreio", href: pedido.tracking_url, icone: Navigation, fundo: "bg-gradient-to-br from-sky-500 to-blue-600",
      titulo: "Rastrear entregador", sub: "Veja onde o seu pedido está agora", acao: "Acompanhar", e2e: "atalho-rastreio" });
  }
  if (emAndamento) {
    cartoes.push({ k: "jogo", href: "/arcade.html", icone: Gamepad2, fundo: "bg-gradient-to-br from-violet-500 to-fuchsia-500",
      titulo: "Joguinho", sub: "Passe o tempo enquanto o seu pedido fica pronto", acao: "Jogar agora", e2e: "atalho-jogo" });
  }
  if (!cartoes.length) return null;
  return (
    <div className={`grid gap-2.5 ${cartoes.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
      {cartoes.map(({ k, ...c }) => <Destaque key={k} {...c} />)}
    </div>
  );
}
